module.exports = __webpack_public_path__ + "img/lw-exp-4.553a9809.jpg";